import React, {useState, useEffect} from 'react'
import {httpGet, httpPost} from '../shared/Config';
import {Button} from 'reactstrap';

import { useTranslation } from 'react-i18next';
import SimpleModal from "../shared/SimpleModal";
import DeleteApiKeyModal from "../shared/DeleteApiKeyModal";
import ApiKeyPasswordModal from '../shared/ApiKeyPasswordModal';

function UserApiKeyModal({isOpen, onCancel, user, orgId, onSaved}) {

    const {t} = useTranslation();

    const [working, setWorking] = useState(false);
    const [apiKeys, setApiKeys] = useState([]);
    const [fetchReady, setFetchReady] = useState(false);
    const [message, setMessage] = useState("");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showApiKeyPasswordModal, setShowApiKeyPasswordModaModal] = useState(false);
    const [keyToDelete, setKeyToDelete] = useState(null);
    const [askPassword, setAskPassword] = useState(false)

    const [fetchError, setFetchError] = useState(false);

    function handleCancel() {
        setWorking(false);
        setFetchError(false);
        setFetchReady(false);
        setApiKeys([]);
        setMessage("");
        setKeyToDelete(null);
        onCancel();
    }

    function onPasswordCancel() {
        setShowApiKeyPasswordModaModal(false);
    }

    function onPasswordOkay(password) {
        setShowApiKeyPasswordModaModal(false);
        generateApiKey(password);
    }

    function tryGenerate() {
        if(askPassword) {
            setShowApiKeyPasswordModaModal(true);
        } else {
            generateApiKey("");
        }
    }

    function generateApiKey(password) {
        if(apiKeys.length < 5) {
            setWorking(true);
            setFetchReady(false);
            let pass = password.password;
            async function generate() {
                const response = await httpPost(`/orgs/${orgId}/generateApiKey`, {user, pass});
                if(response) {
                    if(response.data.error === "no_key") {
                    } else {
                        apiKeys.push(response.data);
                        if(askPassword) {
                            setAskPassword(false);
                        }
                    }
                }
                setWorking(false);
                setFetchReady(true);
            }
    
            generate();
        }
    }

    useEffect(() => {
        if(isOpen) {
            setWorking(true);
            async function checkIfPasswordNeeded() {
                const response = await httpPost(`/orgs/${orgId}/checkIfPasswordNeeded`, {user});
                if(response.data.error) {
                    setMessage(response.data.error);
                    setWorking(false);
                    setFetchError(true);
                } else {
                    setAskPassword(response.data.needsPassword);
                    async function getApiKey() {
                        const response = await httpPost(`/orgs/${orgId}/getApiKey`, {user, both: false});
                        if(response.data.error === "no_key") {
                        } else {
                            setApiKeys(response.data);
                        }
                        setWorking(false);
                        setFetchReady(true);
                    }
                    getApiKey();  
                }
            }
            checkIfPasswordNeeded();

        }
  
    }, [isOpen]);

    function showKey(e, id) {
        const updatedKeys = apiKeys.map(apiKItem =>
                apiKItem.id === id ? {...apiKItem, blur: !apiKItem.blur} : apiKItem
            );
        setApiKeys(updatedKeys);
    }

    function getSpecificApiKey(e, apiKey) {  
        async function getKey() {
            const response = await httpPost(`/orgs/${orgId}/getSpecificKey`, {user, apiKey, both: true});
            if(response.data.error === "error") {
            } else {
                //apiKey.apiKey = response.data.key;
                const updatedKeys = apiKeys.map(apiKItem =>
                        apiKItem.id === apiKey.id ? {...apiKItem, apiKey: response.data.key, blur: !apiKItem.blur} : apiKItem
                    );
                setApiKeys(updatedKeys);
            }
            setWorking(false);
            setFetchReady(true);
        }
        if(!apiKey.apiKey) {
            setWorking(true);
            getKey();
        } else {
            const updatedKeys = apiKeys.map(apiKItem =>
                    apiKItem.id === apiKey.id ? {...apiKItem, blur: !apiKItem.blur} : apiKItem
                );
            setApiKeys(updatedKeys);
        }
    }

    function deleteKey(e, apiK) {
        if(fetchReady){
            setKeyToDelete(apiK);
            setShowConfirmationModal(true);
        }
    }

    function successDelete(id) {
        setApiKeys(preItems => preItems.filter(key => key.id !== id));
        setKeyToDelete(null);
        setShowConfirmationModal(false);
    }
        
    function closeConfirmationModal() {
        setKeyToDelete(null);
        setShowConfirmationModal(false);
    }

    return (
        <SimpleModal isOpen={isOpen}>
                <h3>
                    {t('API_KEYS')}
                </h3>
                <div>
                    {t('API_KEYS_INFO')}
                    <br/>
                    {
                        user ? <React.Fragment>
                            {
                                !user.signed ? <React.Fragment>
                                    <br/>
                                    <span className='error'>{t('USER_NOT_VALIDATED')}</span>
                                </React.Fragment> : <React.Fragment>
                                    <span className={apiKeys.length >= 5 ? 'error' : ''}>{apiKeys.length} / 5</span>
                                    <hr className='smallHr'></hr>
                                    {
                                        fetchReady ? <React.Fragment>
                                            {
                                                apiKeys.length > 0 ? <React.Fragment>
                                                    {
                                                        apiKeys.map((apiK, i) => (
                                                            <div key={i}>
                                                                <div className="row justify-content-center">
                                                                    {t('WEBID')}: <span>{apiK.webId}</span>
                                                                </div>
                                                                {
                                                                    apiK.apiKey ? <React.Fragment>
                                                                        <div className="row justify-content-center">
                                                                            {t('APIKEY')}: <span className={apiK.blur ? 'blurred' : ''}>{apiK.apiKey}</span>
                                                                        </div>
                                                                    </React.Fragment> : <React.Fragment>
                                                                        <div className="row justify-content-center">
                                                                            {t('APIKEY')}: <span className="blur">xxxx4xxxFxxxxxUxxx5xxxxNxx3xxxxCxxx</span>
                                                                        </div>
                                                                        {/*<div className="flex justify-content-center">
                                                                            <button className={'btn btn-link btn-primary mt-5 mb-5'} color="secondary" onClick={(e) => getSpecificApiKey(e, apiK)}>
                                                                                {t('SHOW_API_KEY')}
                                                                            </button>
                                                                        </div>*/}
                                                                    </React.Fragment>
                                                                }
                                                                <div className="flex flex-row justify-content-center">
                                                                    <button className={'btn btn-link btn-primary mt-5 mb-5'} color="secondary"  onClick={(e) => getSpecificApiKey(e, apiK)}>
                                                                        {
                                                                            apiK.blur ? <React.Fragment>
                                                                                {t('SHOW')}
                                                                            </React.Fragment> : <React.Fragment>
                                                                                {t('HIDE')}
                                                                            </React.Fragment>
                                                                        }
                                                                    </button>
                                                                    <button className={'btn btn-link btn-primary mt-5 mb-5'} color="secondary"  onClick={(e) => deleteKey(e, apiK)}>
                                                                        {t('DELETE_API_KEY')}
                                                                    </button>
                                                                </div>
                                                                <hr className='smallHr'></hr>
                                                            </div>
                                                        ))
                                                    }
                                                        {/*<div className="row justify-content-center">
                                                            {t('WEBID')}: <span c>{webId}</span>
                                                        </div>*/}
                                                        {/*
                                                            apiKey ? <React.Fragment>
                                                                <div className="row justify-content-center">
                                                                    {t('APIKEY')}: <span className={blur ? 'blurred' : ''}>{apiKey}</span>
                                                                </div>
                                                                <div className="d-flex justify-content-center">
                                                                    <button className={'btn btn-outline btn-primary mt-5 mb-5'} color="secondary"  onClick={showKey}>
                                                                        {
                                                                            blur ? <React.Fragment>
                                                                                {t('SHOW')}
                                                                            </React.Fragment> : <React.Fragment>
                                                                                {t('HIDE')}
                                                                            </React.Fragment>
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </React.Fragment> : <React.Fragment>
                                                                De clic en el boton de abajo para mostrar su ApiKey.
                                                                <br/>
                                                                <div className="d-flex justify-content-center">
                                                                    <button className={'btn btn-outline btn-primary mt-5 mb-5'} color="secondary"  onClick={getApiKey}>
                                                                        {t('SHOW_API_KEY')}
                                                                    </button>
                                                                </div>
                                                            </React.Fragment>
                                                        */}
                                                    {t('WARNING_KEYS')}
                                                    {
                                                        message ? <React.Fragment>
                                                            <span style={{marginBottom:'2%', fontWeight: 'bold', color: 'red'}}>{t(message)}</span>
                                                        </React.Fragment> : null
                                                    }
                                                </React.Fragment> : <React.Fragment>
                                                {t('NO_KEYS')}
                                                </React.Fragment>
                                            }
                                        </React.Fragment> : <React.Fragment>
                                            {t('LOADING')}
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                        </React.Fragment> : null
                    }
                </div>
                <div className={'modal-action'}>
                    {
                        user ? <React.Fragment>
                            <button disabled={fetchError || working || apiKeys.length >= 5 || !user.signed} className={'btn btn-primary mt-5 mb-5'}  onClick={tryGenerate}>{t('GENERATE_API_KEYS')}</button>
                        </React.Fragment> : null
                    }
                    <button disabled={working} className={'btn btn-outline btn-primary mt-5 mb-5'} color="secondary" onClick={handleCancel}>{t('CANCEL')}</button>
                </div>
                <DeleteApiKeyModal isOpen={showConfirmationModal}
                    onCancel={closeConfirmationModal}
                    onOk={successDelete}
                    orgId={orgId}
                    user={user}
                    apiKey={keyToDelete}
                    title="DELETE_API_KEYS">
                        <span>{t('ARE_YOU_SURE_DELETE_KEYS')}</span>
                        <br/>
                        <p>{t('CONTINUE_QUESTION')}</p>
                </DeleteApiKeyModal>                
                <ApiKeyPasswordModal isOpen={showApiKeyPasswordModal}
                    onCancel={onPasswordCancel}
                    onOk={onPasswordOkay}
                    title="API_KEY_PASSWORD_TITLE">
                        <span>{t('API_KEY_PASSWORD')}</span>
                        <br/>
                        <span>{t('PASSWORD_LENGTH')}</span>
                        <br/>
                        <br/>
                        <span>{t('API_KEY_PASSWORD_WEBHOOK')}</span>
                        <br/>
                        <a href="https://firmamex.com/developers/login" target="_blank">{t('DEVELOPERS_PORTAL')}</a>
                        <br/>
                        <br/>
                </ApiKeyPasswordModal>
        </SimpleModal>
    )
}

export default UserApiKeyModal;
 